import React from "react";

const Title = ({ children }) => (
  <h3 className="section-title text-center text-white fs-1">{children}</h3>
);

export default Title;
